/**
 * Inscription à la newsletter, depuis le champ présent en footer et la modale associée.
 */
$(document).ready(function(){
    "use strict";
    var $newsletterModal = $('.modal-newsletter-subscription');
    var $form = $('form', $newsletterModal);

    // Soumission de l'input email seul, présent en footer, qui affiche la modale d'inscription.
    $('.js-newsletter-registration').submit(function (e) {
        e.preventDefault();

        // Actualise le token de session
        var getTokenUrl = $('.modal-newsletter-subscription #_token-url').attr('href');

        $.get(getTokenUrl, function (data) {
            if( data ) {
                $('.modal-newsletter-subscription input[name="_token"]').val(data);
            }
            $newsletterModal.modal('show');
            $('input[name="email"]', $newsletterModal).val($('[name="email"]', $(this)).val());
        });
    });

    // Soumission de la modale d'inscription
    $form.ajaxForm({
        success: function (data) {
            if(typeof HegydGtm !== "undefined"){
                HegydGtm.pushToDatalayer({'newsletter-inscription-ok' :{'event' : 'newsletter-inscription-ok','gtm-newsletter-inscription-ok' : 'success'}});
            }
            swal("", "Vous êtes inscrit à la newsletter !", "success");
            $("[name='email']", $(".js-newsletter-registration")).val("");

            $newsletterModal.modal('hide');

            $('input[type="text"]', $form).val('');
            $('input[type="checkbox"]', $form).prop('checked', false);
        },
        error: function (data, error, msg) {
            var $error = $('<div/>').addClass('alert alert-block alert-danger')
                .html('' +
                    '<button data-dismiss="alert" class="close close-sm" type="button">' +
                    '   <i class="fa fa-times"></i>' +
                    '</button>' + HegydCore.getModalOutputData(data.responseJSON)
                );
            $form.prepend($error);

            // En cas d'erreur, il est nécessaire de rafraîchir le token du recaptcha.
            // La fonction refreshReCaptchaV3 est définie dans le composant GoogleRecaptcha.js.
            if (typeof window.refreshReCaptchaV3 !== "undefined") {
                window.refreshReCaptchaV3('save_newsletter_id', 'save_newsletter');
            }
        }
    });
});
